import reduxCrud from 'redux-crud';

const demandsReducers = reduxCrud.Map.reducersFor('demands', {
  key: 'id',
});

export default demandsReducers;
